import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { Play, Pause } from 'lucide-react';
const videos = [{
  title: 'Bathroom Remodel Walkthrough',
  url: 'https://cdn.magicpatterns.com/uploads/rPo763CyWB1Z2FaD1e85Qq/WhatsApp%20Video%202026-04-19%20at%2011.26.34%20PM%20(3).mp4'
}, {
  title: 'Shower Enclosure Installation',
  url: 'https://cdn.magicpatterns.com/uploads/kdxCP8XfqsfAz6hRMvLLL7/WhatsApp%20Video%202026-04-19%20at%2011.26.50%20PM.mp4'
}];
const VideoPlayer = ({
  video
}: {
  video: {
    title: string;
    url: string;
  };
}) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);
  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };
  return <div className="group" data-id="element-278">
      <div className="relative aspect-[9/16] md:aspect-video rounded-sm overflow-hidden mb-4 bg-gray-900 cursor-pointer shadow-xl" onClick={togglePlay} data-id="element-279">
        <video ref={videoRef} src={video.url} className="w-full h-full object-cover" loop playsInline onEnded={() => setIsPlaying(false)} data-id="element-280" />

        {!isPlaying && <div className="absolute inset-0 flex items-center justify-center bg-black/20 group-hover:bg-black/40 transition-colors duration-300" data-id="element-281">
            <div className="w-16 h-16 bg-accent/90 text-white rounded-full flex items-center justify-center shadow-lg transform group-hover:scale-110 transition-transform duration-300" data-id="element-282">
              <Play fill="currentColor" size={24} className="ml-1" data-id="element-283" />
            </div>
          </div>}

        {isPlaying && <div className="absolute inset-0 flex items-center justify-center opacity-0 hover:opacity-100 bg-black/20 transition-opacity duration-300" data-id="element-284">
            <div className="w-16 h-16 bg-black/60 text-white rounded-full flex items-center justify-center shadow-lg backdrop-blur-sm" data-id="element-285">
              <Pause fill="currentColor" size={24} data-id="element-286" />
            </div>
          </div>}
      </div>
      <h4 className="text-xl font-serif font-bold group-hover:text-accent transition-colors" data-id="element-287">
        {video.title}
      </h4>
    </div>;
};
export function Videos() {
  return <section id="videos" className="py-24 bg-primary text-white" data-id="element-288">
      <div className="container mx-auto px-6 md:px-12" data-id="element-289">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-290">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-291">
            <h2 className="text-accent font-medium tracking-widest uppercase text-sm mb-3" data-id="element-292">
              In Action
            </h2>
            <h3 className="text-4xl md:text-5xl font-serif font-bold mb-6" data-id="element-293">
              Videos of Our Work
            </h3>
            <p className="text-gray-300 text-lg" data-id="element-294">
              Join us in the day-to-day of our projects and see firsthand the
              dedication and professionalism of our team.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-4xl mx-auto" data-id="element-295">
          {videos.map((video, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} data-id="element-296">
              <VideoPlayer video={video} data-id="element-297" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}